// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/
html,
body,
div,
span,
iframe,
p,
a,
img,
strong,
b,
u,
i,
ol,
ul,
li,
form,
canvas {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
html {
  width: 100%;
}
body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

a {
  text-decoration: none;
  -webkit-backface-visibility: hidden;
}

li {
  list-style: none;
}

html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  -webkit-user-select: none;
          user-select: none;
}

html,
body {
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif !important;
  overflow-x: hidden !important;
  /* font-weight: 500; */
}
option::-ms-expand {
  display: none;
}
option {
  appearance: none;
}
/* --背景色字体颜色--*/
option:hover {
  color: #fff;
  background-color: #1e90ff;
}
.epub-container {
  overflow-x: hidden !important;
}
input,
textarea,
input::placeholder,
textarea::placeholder {
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif !important;
  font-weight: 500 !important;
  line-height: 1.25 !important;
}
input,
textarea {
  color: inherit !important;
  line-height: 1.25 !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/reset.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;;;;;;;;;;;;;;;;;EAiBE,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;;EAIE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;EAEE;yFACuF;EACvF,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EAGE,gBAAgB;AAClB;AACA,eAAe;AACf;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;;;;EAIE;yFACuF;EACvF,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B","sourcesContent":["/* http://meyerweb.com/eric/tools/css/reset/\n   v2.0 | 20110126\n   License: none (public domain)\n*/\nhtml,\nbody,\ndiv,\nspan,\niframe,\np,\na,\nimg,\nstrong,\nb,\nu,\ni,\nol,\nul,\nli,\nform,\ncanvas {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\nhtml {\n  width: 100%;\n}\nbody {\n  line-height: 1;\n}\n\nol,\nul {\n  list-style: none;\n}\n\nblockquote,\nq {\n  quotes: none;\n}\n\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: \"\";\n  content: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\na {\n  text-decoration: none;\n  -webkit-backface-visibility: hidden;\n}\n\nli {\n  list-style: none;\n}\n\nhtml,\nbody {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  user-select: none;\n}\n\nhtml,\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,\n    Ubuntu, Cantarell, \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif !important;\n  overflow-x: hidden !important;\n  /* font-weight: 500; */\n}\noption::-ms-expand {\n  display: none;\n}\noption {\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n}\n/* --背景色字体颜色--*/\noption:hover {\n  color: #fff;\n  background-color: #1e90ff;\n}\n.epub-container {\n  overflow-x: hidden !important;\n}\ninput,\ntextarea,\ninput::placeholder,\ntextarea::placeholder {\n  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,\n    Ubuntu, Cantarell, \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif !important;\n  font-weight: 500 !important;\n  line-height: 1.25 !important;\n}\ninput,\ntextarea {\n  color: inherit !important;\n  line-height: 1.25 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
